import React, { useEffect, useState, useRef } from 'react';
// import { makeStyles, useTheme } from '@material-ui/core/styles';
import { makeStyles, useTheme } from '@mui/styles';

import {
    Button, Paper, MobileStepper, Typography, Card, CardActionArea, CardActions, CardContent, Slide, CardMedia, Dialog, DialogTitle, AppBar, Toolbar,
    DialogContent, Grid, ListItem, List, TextField, MenuItem, DialogActions, Menu, Box, Stack, Zoom,Backdrop, CircularProgress
} from '@mui/material';

import { LocalizationProvider, DatePicker, DesktopDateTimePicker } from '@mui/x-date-pickers';

import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment'

import photo01 from "../Pictures/photo01.jpg";
// import photo02 from "./pictures/photo02.jpg";
import photo03 from "../Pictures/photo03.jpg";
// import photo04 from "./pictures/photo04.jpg";
import photo06 from "../Pictures/photo06.jpg";
import photo08 from "../Pictures/photo08.jpg";
import CustomModal from "../components/Modal/CustomModal";
// import { FormattedMessage } from "react-intl";
import logo from '../Pictures/logo.svg';

import _, { omit, pick, round, slice } from 'lodash';
import axios from "axios";
import Qs from "qs";
import { actions } from "../reducers/app";
import { useDispatch, useSelector } from "react-redux";
import PF from "../_Services/publicFunction";
// import MyBackdrop from './components/BackDrop/BackDrop';
// import Backdrop from "@material-ui/core/Backdrop";
// import { indigo, green, red } from '@material-ui/core/colors';
import { indigo, green, red, teal } from '@mui/material/colors';
import { GTranslate, Timer } from '@mui/icons-material';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import CakeOutlinedIcon from '@mui/icons-material/CakeOutlined';

import { FormattedMessage, injectIntl, intlShape, useIntl } from 'react-intl';
import SwipeableViews from 'react-swipeable-views';
import { autoPlay, virtualize } from 'react-swipeable-views-utils';

// import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
// import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
// import virtualize from 'react-swipeable-views/lib/virtualize';
import { mod } from 'react-swipeable-views-core';
// import AddIcCallIcon from '@mui/icons-material/AddIcCall';
import AddIcCallIcon from '@mui/icons-material/Call';
// import RoomIcon from '@mui/icons-material/Room';
import LocationOnIcon from '@mui/icons-material/LocationOn';

import { DarkModeSwitch } from 'react-toggle-dark-mode';
import useSound from 'use-sound';
import switchlight from '../components/sounds/switchlight.wav';
import dayjs from 'dayjs';
import 'dayjs/locale/zh-tw';
import 'dayjs/locale/en';

import AuthCode from 'react-auth-code-input';
import Countdown from 'react-countdown';
import CachedIcon from '@mui/icons-material/Cached';
import Fingerprint from '@mui/icons-material/Fingerprint';
import { useSnackbar } from "notistack";
import { useNavigate } from 'react-router-dom';
import { useForm, Controller } from "react-hook-form";
import { isMobile, browserName, deviceType, isAndroid, isIOS, isMacOs, isWindows, isMobileOnly, isTablet, isDesktop } from 'react-device-detect';


const AutoPlaySwipeableViews = autoPlay(virtualize(SwipeableViews));

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="down"
        ref={ref} {...props}
        timeout={1000}
    // easing={{
    //     enter: "cubic-bezier(0, 1.5, .8, 1)",
    //     exit: "linear"
    // }}
    />;
});

const ZoomTransition = React.forwardRef(function Transition(props, ref) {
    return <Zoom
        ref={ref} {...props}
        timeout={500}
    // easing={{
    //     enter: "cubic-bezier(0, 1.5, .8, 1)",
    //     exit: "linear"
    // }}
    />;
});


const useStyles = makeStyles(theme => ({
    root: {
        // maxWidth: 600,
        flex: 1
    },
    root2: {
        padding: 0,
        '&:first-child ': {
            padding: 0,
        }
    },
    appBar: {
        position: 'relative',
        backgroundColor: indigo[500],
    },
    media: {
        height: 760,
        width: "100%",
        objectFit: 'cover',
        // "-o-transition": "opacity 1s ease-in-out",
        transition: "opacity 2s ease-in-out"
        // paddingTop: '56.25%', // 16:9,"
    },
    header: {
        display: 'flex',
        alignItems: 'center',
        height: 50,
        paddingLeft: theme.spacing(4),
        backgroundColor: theme.palette.background.default,
    },
    img: {
        height: 700,
        // display: 'block',
        // maxWidth: 400,
        overflow: 'hidden',
        objectFit: 'cover',

        width: '100%',
    },
    button: {
        borderRight: "3px solid transparent",
        "&:hover": {
            borderRightColor: "blue",
            borderRight: "3px solid",
        },
        "&:focus": {
            borderRightColor: "blue",
            borderRight: "3px solid",
        }
    },
    listStyleNone: {
        width: "45px",
        '& div': {
            width: '45px'
        }
    },
    AuthInput: {
        // alignItems: "center",
        display: "flex",
        justifyContent: "center",
        '& div': {
            '& input': {
                width: 45,
                height: 45,
                margin: 5,
                textAlign: 'center',
                backgroundColor: theme.palette.mode === 'dark' ? '#000000' : "#FFFFFF"

            }
        }
    }

}));



function Login(props) {
    const [loading, setLoading] = useState(false); //緩衝頁面
    const { enqueueSnackbar } = useSnackbar();
    const { register, formState: { errors }, handleSubmit, formState, control, onBlur, onChange } = useForm();

    const [Timerer, setTimerer] = useState(null);
    const renderer = ({ hours, minutes, seconds, completed }) => {
        if (completed) {
            // Render a complete state
            return <Button variant="outlined" onClick={handleSendMsg} startIcon={<CachedIcon />}>
                重新發送
            </Button>;
        } else {
            // Render a countdown
            // console.log(minutes.toString().length===1?'0'+minutes:minutes);
            return (
                <Button variant="outlined" disabled>
                    {minutes.toString().length === 1 ? '0' + minutes : minutes}:{seconds.toString().length === 1 ? '0' + seconds : seconds} 重新發送
                </Button>
            );
        }
    };
    // React.useEffect(() => {
    //     console.log(formState.isValid);

    // }, [formState])
    const { history } = props;
    const { i18n } = useSelector(state => ({
        i18n: state.app.i18n,
    }));
    const { dark } = useSelector(state => ({
        dark: state.app.dark,
    }));
    const { app } = useSelector(state => ({
        app: state.app,
    }));
    const dispatch = useDispatch();
    const [playActive] = useSound(
        switchlight,
        { volume: 0.5 }
    );
    const intl = useIntl();
    const formRef = React.createRef();
    const classes = useStyles();
    const [open, setOpen] = React.useState(true)
    const [settingObj, setObj] = React.useState({
        UserName: { label: "姓名", name: "UserName", type: "text", required: true, helperText: "required", xs: 12, sm: 12, md: 12, lg: 12, minLength: 2, maxLength: 50, pattern: "^[^0-9]+$", placeholder: "王小明" },
        BirthDate: { label: "出生日期", name: "birthDate", type: "date", required: true, helperText: "required", xs: 12, sm: 12, md: 12, lg: 12, disableFuture: true, openTo: "year", placeholder: "2000/01/01" },
        PersonalId: { label: "身分證字號", name: "personalId", type: "text", required: true, helperText: "required", xs: 12, sm: 12, md: 12, lg: 12, minLength: 8, maxLength: 10, placeholder: "A123456789" }
    })
    const AuthInputRef = useRef(null)
    const handleTxtChange = e => {
        const { name, value } = e.target;
        setUser(prevstate => ({
            ...prevstate,
            [name]: value.trim()
        }));
    }
    const { PersonalIdref, ...PersonalIdinputProps } = register("PersonalId", {
        required: { value: true, message: "必須" }, minLength: { value: 8, message: "字元不足" },
        //  pattern: { value: /^[^0-9]+$/, message: "非數字" },
        onChange: handleTxtChange
    });
    const handleDateChange = (name, value) => {
        // console.log(name, value)
        setUser(prevstate => ({
            ...prevstate,
            [name]: value === null ? null : value.format('YYYY/MM/DD')
        }));
    }
    // const Birth = register("BirthDate", {
    //     required: { value: true, message: "必須2" },
    //     pattern: { value: /^\d{4}[\/\-](0?[1-9]|1[012])[\/\-](0?[1-9]|[12][0-9]|3[01])$/, message: "非數字" },
    //     // onChange: e => handleDateChange("BirthDay", e)
    // }
    // );
    const [anchorEl, setAnchorEl] = React.useState(null);
    const TranslateOpen = Boolean(anchorEl);


    const handleTranslateClose = () => {
        setAnchorEl(null);
    };
    const handleI18nChange = (event, lang) => {
        // moment.locale(lang);
        dispatch(actions.LANG_SET(lang));
        setAnchorEl(null);
        playActive();
    };
    React.useEffect(() => {
        //載入彈窗
        let timer;


        if (true) {
            timer = setInterval(() => {
                setDoor((prevProgress) =>
                    prevProgress >= ArrayDoor.length - 1 ? 0 : prevProgress + 1
                );
            }, 5000);
        }

        return () => {
            clearInterval(timer);
        };
    }, [])

    const [user, setUser] = React.useState({
        BirthDate: null
    })
    const [AuthOpen, setAuthOpen] = React.useState(false);


    useEffect(() => {
        // console.log(user)

    }, [user])
    // const handleToggle = () => {
    //     setBOpen(!Bopen);
    // };
    const handleClose = () => {
        setUser({
            BirthDate: null, PersonalId: "", email: "", sogi: ""
        });
        setAuthOpen(false)
    }

    const onSubmit = e => {
        
       if (!disableSubmit) return; // local 判斷即可
        setdDsableSubmit(false);
        setLoading(true);//開啟lodding
        let OS = "Others"
        if (isAndroid) {
            // 安卓系统(安卓手机, 安卓平板...)
            OS = "Android"
        } else if (isIOS) {
            // iOS系统(iPhone, iPad, iPod...)
            OS = "iOS"

        } else if (isMacOs) {
            // macOS系统(Mac, MacBook, MacBook Pro...)
            OS = "MacOs"

        } else if (isWindows) {
            // Windows系统
            OS = "Windows"
        }

        let device = "Others";
        if (isMobileOnly) {
            // 手机
            device = "Cellphone"
        } else if (isTablet) {
            // 平板(iPad, 安卓平板...)
            device = "Pad"
        } else if (isDesktop) {
            // 桌面端浏览器
            device = "Desktop"
        }

        if (validator()) {
            // console.log("ＰＡＳＳ")

            PF.get_ip()
                .then(data => {
                    ({
                        region: user.ipRegion,
                        country_name: user.ipCountry,
                        ip: user.ipAddress
                    } = data);
                    return user;
                })
                .then(user => {

                    user.browserName = browserName;
                    user.operationSystem = OS;
                    user.device = device;
                    PF.instance({
                        method: "post",
                        url: PF.url2 + "/Login/Login",
                        data: Qs.stringify({ action: "1", parameter: user }),
                    })
                        .then(function (response) {
                            setLoading(false); //  關閉 loading
                            const { TotalRecord, rows } = response.data;
                            setdDsableSubmit(true);

                            if (TotalRecord === 0) {
                                // alert("抱歉,查無您的預約資料\r\n請致電 04-2255-2555 #168 企業健檢預約查詢")
                                alert(intl.formatMessage({ id: "app.LoginCantFound" }));
                                //清除登入請之重填
                                setUser({
                                    BirthDate: null, PersonalId: "",
                                });

                            } else {

                                // console.log(rows[0]);
                                const { sogi, email } = rows[0];
                                setUser(prevstate => ({
                                    ...prevstate,
                                    sogi: sogi,
                                    email: email
                                }));
                                //發送Message API
                                setAuthOpen(true);
                                handleSendMsg();

                            }

                            // } else if (TotalRecord === doneQ && rows[0].SpecialCheckDate === null) {
                            //     let isconfirm = window.confirm("您所需要填寫的問卷均已完成，使否需要修改?");
                            //     if (isconfirm) {

                            //         sessionStorage.setItem("token", JSON.stringify(token));
                            //         dispatch(actions.token(token));
                            //         dispatch(actions.UserInfo(UserInfo));
                            //         history.push(`${process.env.PUBLIC_URL}/Admin`);
                            //     }
                            // } else if () { //尚有未完成問卷
                            //     sessionStorage.setItem("token", JSON.stringify(token));
                            //     dispatch(actions.token(token));
                            //     dispatch(actions.UserInfo(UserInfo));
                            //     dispatch(actions.QUESTS_SET(beingQ));
                            //     history.push(`${process.env.PUBLIC_URL}/Admin`);
                            //     setUser({
                            //         UserName: null, birthDate: null, personalId: null, BarCodeStr: '',
                            //     });
                            // }
                        })
                })
        }

    }

    const validator = () => {
        const form = formRef.current; //參數1

        if (form.checkValidity()) {
            console.log("全部通過");
            for (let i = 0; i < form.elements.length; i++) {
                const element = form.elements[i];
                if (Object.keys(settingObj).includes(element.name)) {
                    setObj(prevState => ({
                        ...prevState,
                        [element.name]: omit(prevState[element.name], ["error"])
                    }))
                }
            }
            return true;
        } else {

            for (let i = 0; i < form.elements.length; i++) {
                const element = form.elements[i];
                if (element.tagName !== 'button' && element.willValidate && !element.validity.valid) {  //提交按鈕不用驗證
                    if (Object.keys(settingObj).includes(element.name)) {
                        setObj(prevState => ({
                            ...prevState,
                            [element.name]: { ...prevState[element.name], error: true, helperText: intl.formatMessage({ id: element.validationMessage }) }
                        }))
                    }
                    // console.log(element.validationMessage)

                } else {//驗證通過，自訂訊息
                    //有在settingObj的
                    if (Object.keys(settingObj).includes(element.name)) {
                        setObj(prevState => ({
                            ...prevState,
                            [element.name]: omit(prevState[element.name], ["error"])
                        }))
                    }

                }
            }
            return false;
        }
    }

    const handleSendMsg = f => {
        //重新寄送清空驗證碼登打
        AuthInputRef.current?.clear();
        //重置timer
        setTimerer(Date.now() + 90000);
        PF.instance({
            method: "post",
            url: PF.url2 + "/Login/Insert",
            data: Qs.stringify({ action: "1", parameter: user }),
        })
            .then(function (response) {
                const { TotalRecord, rows } = response.data;
                if (TotalRecord === 0) {
                    // alert("抱歉,查無您的預約資料\r\n請致電 04-2255-2555 #168 企業健檢預約查詢")
                    alert(intl.formatMessage({ id: "app.LoginCantFound" }));
                    //清除登入請之重填
                    setUser({
                        BirthDate: null, PersonalId: "", sogi: "", email: ""
                    });
                    setAuthOpen(false);

                } else {
                    // console.log(rows);


                }

            });

    }


    const ArrayDoor = [photo01, photo06, photo03, photo08]
    const [door, setDoor] = React.useState(0);
    const navigate = useNavigate();

    const [VerifyCount, setVerifyCount] = useState(0);
    const handleValidationChange = (res) => {
        // console.log(res)
        // setPassword(res);
        //增加密碼
        setUser(prevstate => ({
            ...prevstate,
            Password: res
        }));

    };
    const [disableSubmit, setdDsableSubmit] = React.useState(true)

    const handleVerify = prop => {
        PF.instance({
            method: "post",
            url: PF.url2 + "/Login/Verify",
            data: Qs.stringify({ action: "1", parameter: user }),
        })
            .then(function (response) {
                const { TotalRecord, rows, Token } = response.data;
                if (TotalRecord === 0) {
                    // alert("抱歉,查無您的預約資料\r\n請致電 04-2255-2555 #168 企業健檢預約查詢")
                    alert(intl.formatMessage({ id: "app.LoginCantFound" }));
                    //清除登入請之重填

                    //重新寄送清空驗證碼登打
                    AuthInputRef.current?.clear();
                    setVerifyCount(prev => prev + 1)
                    let c = VerifyCount + 1;
                    enqueueSnackbar("驗證碼錯誤" + c + "次(累計超過五次將重新登入)", { variant: "error", style: { whiteSpace: 'pre-line' } });

                    if (c >= 5) {
                        //清除登入請之重填
                        setUser({
                            BirthDate: null, PersonalId: "", sogi: "", email: ""
                        });
                        //重新登入會刷新驗證碼
                        enqueueSnackbar("麻煩重新登入", { variant: "error", style: { whiteSpace: 'pre-line' } });
                        setAuthOpen(false);
                    }
                } else {
                    // console.log(rows);
                    //切換頁面
                    enqueueSnackbar("尊敬的顧客您好", { variant: "success", style: { whiteSpace: 'pre-line' } });
                    dispatch(actions.UserInfo(user));
                    // history.push(`${process.env.PUBLIC_URL}/Admin`);
                    navigate(`/Admin`)
                    dispatch(actions.TOKEN_SET(Token));
                    localStorage.setItem("token", Token);

                }

            })

    }
    // console.log("Errors:", errors);
    return (
        <React.Fragment>
            <Card>
                <CardActionArea onClick={() => { setOpen(true); }}>
                    <SwipeableTextMobileStepper className={classes.media} />
                    <CardContent>
                        <Typography gutterBottom variant="h5" component="h2" style={{ color: !dark ? "#000000" : "#FFFFFF", fontWeight: "700" }}>
                            <FormattedMessage id={"晨悅預防醫學"} />
                        </Typography>
                        <Typography variant="body2" color="textSecondary" component="p" style={{ marginLeft: "20px", color: "#F2781F", fontWeight: "bold" }}>
                            <FormattedMessage id={"健康人生，攜手晨悅"} />
                        </Typography>
                    </CardContent>
                </CardActionArea>
                <CardActions>
                    <Button size="small" color="primary" variant="contained" style={{ backgroundColor: indigo[500] }}>
                        <a href="https://www.mornjoy.com.tw/" style={{ textDecoration: "none", color: "white" }}>WebSite</a>
                    </Button>
                    <Button size="small" color="primary" variant="contained" style={{ backgroundColor: indigo[500] }}>
                        <a href="http://mj.mornjoy.com.tw/EBook/index.html" style={{ textDecoration: "none", color: "white" }}>e-Book</a>
                    </Button>
                    <Button size="small" color="primary" variant="contained" style={{ backgroundColor: indigo[500], justifyContent: "center", alignItems: "center", display: "flex", }}>
                        <a href="https://goo.gl/maps/w7oP8xanRMfPV7vMA" style={{ textDecoration: "none", color: "white", justifyContent: "center", alignItems: "center", display: "flex" }}><LocationOnIcon fontSize="small" style={{ color: red[700] }} />Google Map</a>
                    </Button>
                    <Button size="small" color="primary" variant="contained" style={{ backgroundColor: indigo[500], justifyContent: "center", minHeight: 30.75 }}>
                        <a href="tel:04-22552555" style={{ textDecoration: "none", color: "white", justifyContent: "center", alignItems: "center", display: "flex", }}><AddIcCallIcon style={{ color: green[500] }} fontSize="small" /></a>
                    </Button>
                </CardActions>
            </Card>
            <Dialog
                open={open}
                TransitionComponent={Transition}
                BackdropProps={{
                    // open: false
                    // backgroundColor: "transparent",
                    invisible: true,
                }}
                style={{ pointerEvents: 'none' }} //可以跟後面互動
                PaperProps={{
                    style: { pointerEvents: 'auto', overflowX: "hidden" }, className: classes.shrinkTitle,//可以跟後面互動
                    // sx: { position: "fixed", top: 220, m: 0 }//位置自定義
                }}
                scroll={'paper'}
            >
                <DialogTitle className={classes.root2}>
                    <Toolbar style={{ width: "100%", backgroundColor: indigo[500] }}>
                        <Typography variant="h6" className={classes.title} style={{ flex: 1 }}>
                            <img src={logo} style={{ pointerEvents: "none", paddingTop: "10px" }} />
                        </Typography>
                        <DarkModeSwitch
                            style={{ marginBottom: '2rem', float: "right" }}
                            checked={dark}
                            onChange={() => dispatch(actions.THEME_SET({ theme: !dark }))}
                            onMouseDown={(e) => {
                                e.preventDefault();
                                // e.stopPropagation();
                                playActive()
                            }}
                            // style={{ width: "50px" }}
                            size={20} />
                    </Toolbar>
                </DialogTitle>
                <form onSubmit={handleSubmit(onSubmit)} ref={formRef} style={{ display: "flex", flexDirection: "column", overflowY: "auto" }} noValidate>
                    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={app.i18n.locale}>
                        <DialogContent dividers={true} style={{ overflowX: "hidden" }} className={classes.root2}>
                            <List style={{ width: "100%" }}>
                                <ListItem button>
                                    <Grid container spacing={0} alignItems="flex-end">
                                        <Grid item xs={2}><CreditCardIcon /></Grid>
                                        <Grid item xs={10}>
                                            <TextField
                                                variant="standard"
                                                label={<FormattedMessage id={"personalId"} key={"personalId"} />}
                                                placeholder='A123456789'
                                                name='PersonalId'
                                                fullWidth
                                                required
                                                value={user.PersonalId || ""}
                                                autoComplete="off"
                                                error={!!errors.PersonalId}
                                                helperText={errors?.PersonalId?.message}
                                                inputRef={PersonalIdref}
                                                {...PersonalIdinputProps}

                                            // onChange={handleTxtChange}
                                            // error={settingObj.PersonalId.error}
                                            // helperText={settingObj.PersonalId.error ? intl.formatMessage({ id: settingObj.PersonalId.helperText }) : ""}
                                            // inputProps={{
                                            //     minLength: 8
                                            // }}
                                            />
                                        </Grid>

                                    </Grid>
                                </ListItem>
                                <ListItem button>
                                    <Grid container spacing={0} alignItems="flex-end">
                                        <Grid item xs={2}><CakeOutlinedIcon /></Grid>
                                        <Grid item xs={10}>
                                            {/* <DesktopDateTimePicker
                                                inputFormat="YYYY/MM/DD"
                                                label={<FormattedMessage id={"birthDate"} key={"birthDate"} />}
                                                openTo="year"
                                                disableFuture
                                                views={['year', 'month', 'day']}
                                                value={user.BirthDate}
                                                onChange={(newvalue) => handleDateChange("BirthDate", newvalue)}
                                                renderInput={(params) =>
                                                    <TextField
                                                        {...params}
                                                        variant='standard'
                                                        fullWidth
                                                        error={settingObj.BirthDate.error}
                                                        helperText={settingObj.BirthDate.error ? intl.formatMessage({ id: settingObj.BirthDate.helperText }) : ""}
                                                        required
                                                        name="BirthDate"
                                                        autoComplete="off"
                                                        inputProps={{
                                                            ...params.inputProps,
                                                            placeholder: "2000/01/01",
                                                            pattern: "[0-9]{4}/(0[1-9]|1[012])/(0[1-9]|1[0-9]|2[0-9]|3[01])"


                                                        }}

                                                    />
                                                }
                                            /> */}
                                            <Controller
                                                control={control}
                                                name="date"
                                                placeholder="2000/01/01"
                                                rules={{
                                                    validate: {
                                                        // min: (date) => isFuture(date) || "Please, enter a future date"
                                                        matchPattern: v => !(/^\d{4}[\/\-](0?[1-9]|1[012])[\/\-](0?[1-9]|[12][0-9]|3[01])$/.test(v)) || '非日期'
                                                    },
                                                    required: { value: true, message: "必填" },
                                                    // pattern: { value: /^\d{4}[\/\-](0?[1-9]|1[012])[\/\-](0?[1-9]|[12][0-9]|3[01])$/, message: "XXXXX" }
                                                    // pattern: {
                                                    //     value: "/[A-Za-z]{3}/",
                                                    //     message: "invalid email address"
                                                    // }
                                                }}
                                                defaultValue={user.BirthDate}
                                                render={({ field: { ref, onBlur, name, onChange, ...field }, fieldState }) => (
                                                    <DesktopDateTimePicker
                                                        {...field}
                                                        inputRef={ref}
                                                        views={['year', 'month', 'day']}
                                                        inputFormat="YYYY/MM/DD"
                                                        openTo="year"
                                                        disableFuture
                                                        value={user.BirthDate}
                                                        onChange={(newvalue) => { onChange(newvalue); handleDateChange("BirthDate", newvalue) }}    //若用選的才有
                                                        label={<FormattedMessage id={"birthDate"} key={"birthDate"} />}
                                                        renderInput={(inputProps) => (
                                                            <TextField
                                                                {...inputProps}
                                                                variant='standard'
                                                                autoComplete="off"
                                                                required
                                                                fullWidth
                                                                onBlur={onBlur}
                                                                name={name}
                                                                placeholder="2000/01/01"
                                                                inputProps={{
                                                                    ...inputProps.inputProps,
                                                                    placeholder: "2000/01/01",
                                                                    pattern: "[0-9]{4}/(0[1-9]|1[012])/(0[1-9]|1[0-9]|2[0-9]|3[01])"


                                                                }}

                                                                error={!!fieldState.error}
                                                                helperText={fieldState.error?.message}
                                                            // inputRef={BirthDateRef}

                                                            // {...BirthDateInputProps}


                                                            />
                                                        )}
                                                    />
                                                )}
                                            />

                                        </Grid>

                                    </Grid>
                                </ListItem>
                                {/* <TextField
                                    variant="standard"
                                    label={<FormattedMessage id={"personalId"} key={"personalId"} />}
                                    placeholder='A123456789'
                                    name='PersonalId'
                                    required
                                    onChange={handleTxtChange}
                                    value={user.PersonalId || ""}
                                    autoComplete="off"
                                    error={!!errors.PersonalId}
                                    helperText={errors?.PersonalId?.message}
                                    inputRef={ref}
                                    {...inputProps}
                                /> */}
                                {/* <DesktopDateTimePicker
                                    inputRef={Birth.ref}

                                    inputFormat="YYYY/MM/DD"
                                    name="BirthDate"
                                    label={<FormattedMessage id={"birthDate"} key={"birthDate"} />}
                                    openTo="year"
                                    disableFuture
                                    views={['year', 'month', 'day']}
                                    value={user.BirthDate}
                                    onChange={(newvalue) => { console.log(newvalue); handleDateChange("BirthDate", newvalue); Birth.onChange(newvalue) }}
                                    renderInput={(params) =>
                                        <TextField
                                            {...params}

                                            onBlur={Birth.onBlur}
                                            variant='standard'
                                            fullWidth
                                            name="BirthDate"
                                            autoComplete="off"
                                            helperText={errors?.BirthDate?.message}
                                            error={!!errors.BirthDate}
                                            {...Birth.inputProps}
                                            {...register('BirthDate')}
                                        />
                                    }

                                /> */}

                            </List>
                        </DialogContent>
                        <DialogActions>
                            <Button size="small" type="submit" color="primary" variant="contained" style={{ width: "95%", cursor: 'pointer', backgroundColor: indigo[500] }} onClick={handleSubmit(onSubmit)}><FormattedMessage id={"app.LoginButton"} key={"app.LoginButton"} /></Button>
                            <Button size="small" color="primary" variant="contained" style={{ cursor: 'pointer', backgroundColor: teal[700] }} onClick={e => { setAnchorEl(e.currentTarget); }}>
                                <GTranslate />
                            </Button>
                            <Menu
                                id="basic-menu"
                                anchorEl={anchorEl}
                                open={TranslateOpen}
                                onClose={handleTranslateClose}
                                MenuListProps={{
                                    'aria-labelledby': 'basic-button',
                                }}
                                value={app.i18n.locale}

                            >
                                <MenuItem style={{ color: app.i18n.locale === "zh-tw" ? "white" : "", backgroundColor: app.i18n.locale === "zh-tw" ? teal[700] : "" }} selected={app.i18n.locale === "zh-tw"} value="zh-tw" onClick={(e) => handleI18nChange(e, "zh-tw")}>繁體中文</MenuItem>
                                <MenuItem style={{ color: app.i18n.locale === "en" ? "white" : "", backgroundColor: app.i18n.locale === "en" ? teal[700] : "" }} selected={app.i18n.locale === "en"} value="en" onClick={(e) => handleI18nChange(e, "en")}>English</MenuItem>
                            </Menu>
                        </DialogActions>
                    </LocalizationProvider>
                </form>
            </Dialog>
            <Dialog
                TransitionComponent={ZoomTransition}
                open={AuthOpen}
                PaperProps={{
                    // sx: { position: "fixed", top: 200, m: 0 }//位置自定義
                }}>
                <DialogTitle>
                    <Typography color="text.secondary" component="div">驗證碼將發送到您下列裝置</Typography>
                    <Stack spacing={1}>
                        <Card variant="outlined">
                            <CardContent>
                                <Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom>
                                    手機
                                </Typography>
                                <Typography variant="h5" component="div">
                                    {user.sogi || ""}
                                </Typography>
                            </CardContent>
                        </Card>

                        <Card variant="outlined">
                            <CardContent>
                                <Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom>
                                    Email
                                </Typography>
                                <Typography variant="h5" component="div">
                                    {user.email || ""}
                                </Typography>
                            </CardContent>
                        </Card>
                        <Countdown renderer={renderer} date={Timerer} key={Timerer} />
                    </Stack>
                    <Typography sx={{ fontSize: 13 }} color="text.secondary" component="div" style={{ textAlign: "center" }}>驗證碼60分鐘內登入有效</Typography>

                </DialogTitle>
                <DialogContent className={classes.AuthInput} dividers>
                    <AuthCode ref={AuthInputRef} onChange={handleValidationChange} allowedCharacters="numeric" length={4} />
                    {/* <button onClick={() => AuthInputRef.current?.clear()}>Clear</button> */}
                </DialogContent>
                <DialogActions style={{ display: "block" }}>
                    <Button variant='outlined' color="error" size='small' onClick={handleClose} >取消</Button>
                    <Button variant='contained' color="success" startIcon={<Fingerprint />} style={{ float: "right" }} onClick={handleVerify} disabled={user.Password?.length !== 4}>確認</Button>
                </DialogActions>
            </Dialog>
            <Backdrop
            sx={{
                color: '#fff',
                zIndex: (theme) => theme.zIndex.drawer + 9999,
                flexDirection: 'column'
            }}
            open={loading}
            >
            <CircularProgress color="inherit" />
            <Typography sx={{ mt: 2 }}>
                請稍後，發送驗證碼中…
            </Typography>
            </Backdrop>


        </React.Fragment >
    );
}

const tutorialSteps = [
    {
        imgPath: photo01,
    },
    {
        imgPath:
            photo03,
    },
    {
        imgPath:
            photo06,
    },
    {
        imgPath:
            photo08,
    },

];

const styles = {
    slide: {
        padding: 15,
        minHeight: 100,
        color: '#fff',
    },
    img: {
        height: 620,
        // display: 'block',
        // maxWidth: 400,
        overflow: 'hidden',
        objectFit: 'cover',

        width: '100%',
    },
}


function SwipeableTextMobileStepper() {
    const classes = useStyles();
    const theme = useTheme();
    const [activeStep, setActiveStep] = React.useState(0);
    const maxSteps = tutorialSteps.length;

    const handleNext = () => {
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
    };

    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };

    const handleStepChange = (step) => {
        setActiveStep(step);
    };
    const SlideRenderer = params => {
        // const classes = useStyles();
        const { index, key } = params;

        switch (mod(index, 4)) {
            case 0:
                return (<img key={key} src={tutorialSteps[0].imgPath} className={classes.img} />);
            case 1:
                return (<img key={key} src={tutorialSteps[1].imgPath} className={classes.img} />);
            case 2:
                return (<img key={key} src={tutorialSteps[2].imgPath} className={classes.img} />);
            case 3:
                return (<img key={key} src={tutorialSteps[3].imgPath} className={classes.img} />);
            default:
                return null;
        }
    }
    


    return (
        <div className={classes.root}>
            <AutoPlaySwipeableViews
                // axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
                // index={activeStep}
                // onChangeIndex={handleStepChange}
                enableMouseEvents
                interval={5000}
                slideRenderer={SlideRenderer}
            // className={classes.img}
            >

            </AutoPlaySwipeableViews>
            {/* <MobileStepper
        steps={maxSteps}
        position="static"
        variant="text"
        activeStep={activeStep}
        nextButton={
          <Button size="small" onClick={handleNext} disabled={activeStep === maxSteps - 1}>
            Next
            {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
          </Button>
        }
        backButton={
          <Button size="small" onClick={handleBack} disabled={activeStep === 0}>
            {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
            Back
          </Button>
        }
      /> */}
        </div>
    );
}

export default injectIntl(Login);